import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { isLessThanBreakpoint } from 'dpl/util/grid';
import BreederProfileTabContent from 'dpl/components/BreederProfile/Show/BreederProfileTabContent';
import BreederProfileTabs from 'dpl/components/BreederProfile/Show/BreederProfileTabs';
import BreederProfileHeader from 'dpl/components/BreederProfile/mobile/components/BreederProfileHeader';
import useBreederProfileMobileLayout from 'dpl/components/BreederProfile/hooks/useBreederProfileMobileLayout';
import ContactQuizSuccessBanner from 'dpl/common/components/ContactQuizSuccessBanner';
import useBuyerApplicationSubmittedAt from 'dpl/common/hooks/useBuyerApplicationSubmittedAt';

import BreederProfileMobileActionsContainer from '../BreederProfileMobileActionsContainer';

const IS_LT_MD = isLessThanBreakpoint('md');

export default function BreederProfileLayoutContainer() {
  const { isNewMobileLayout } = useBreederProfileMobileLayout();
  const {
    server: { breederProfileId }
  } = useSelector(({ server }: any) => ({ server }));
  const {
    hasSubmittedBuyerApplication,
    submittedAtLabel,
    isFetching: isBuyerApplicationFetching
  } = useBuyerApplicationSubmittedAt(breederProfileId);

  useEffect(() => {
    if (!isNewMobileLayout) return;

    const mobileHeader = document.querySelector('#mainHeader .MobileHeader');

    if (!mobileHeader) return;

    // Background color override in new mobile layout
    (mobileHeader as HTMLElement).style.backgroundColor = '#faf7f2';
  }, [isNewMobileLayout]);

  return (
    <div className="BreederProfileLayoutContainer">
      {hasSubmittedBuyerApplication && !IS_LT_MD && (
        <ContactQuizSuccessBanner
          breederProfileId={breederProfileId}
          submittedAtLabel={submittedAtLabel}
        />
      )}
      <BreederProfileHeader />
      <BreederProfileTabs />
      <BreederProfileTabContent />
      <BreederProfileMobileActionsContainer
        hasSubmittedBuyerApplication={hasSubmittedBuyerApplication}
        isBuyerApplicationFetching={isBuyerApplicationFetching}
        submittedAtLabel={submittedAtLabel}
      />
    </div>
  );
}
